import React, { Component } from 'react';
import VertStepContent from './VertStepContent';
import { makeStyles } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import {fromNewDateFormatToDDMMYYYYSlash} from '../../Helpers/dateHelper';

export default function VertStep(props) {

    const classes = useStyles();
    const setStep = () => {
        props.actions.setVertstep(props.id)
    }


    let name = props.name;
    if (props.isComplete && props.chosenValue && props.chosenValue !== '') {
        if(name === 'Date of contract' || name === 'Valid untill (optional)'){            
            name = name + ' - ' + fromNewDateFormatToDDMMYYYYSlash(new Date(props.chosenValue));
        }
        else{
            name = name + ' - ' + props.chosenValue;
        }
    }

    return (
        <div className={classes.stepContainer}>
            {
                props.isInProgress || props.isComplete ?
                    <div className={classes.container}>
                        <div className={classes.circleContainer}>{
                            props.isComplete ?
                                <button className={classes.completeCircle} onClick={() => setStep()} >
                                   <CheckIcon className={classes.checkIcon}></CheckIcon>
                                </button> :
                                props.isInProgress ?
                                    <div className={classes.inprogressCircle}>
                                        <div className={classes.whiteText}>{props.id}</div>
                                    </div> :
                                    <div className={classes.incompleteCircle}>
                                        <div className={classes.blackText}>{props.id}</div>
                                    </div>}
                        </div>
                        <div className={classes.textContainer}>
                            <div className={classes.stepText}>{name}</div>
                        </div>
                    </div> : <div></div>
            }
            {props.isInProgress ? <VertStepContent {...props}></VertStepContent> : <div></div>}
        </div>
    )

}


const useStyles = makeStyles({
    stepContainer: {
        // flex: 1,
        height: 60
    },
    container: {
        // flex: 1,
        flexDirection: "row",
    },
    circleContainer: {
        // flex: 1,
        height: 50,
        float:"left"
    },
    textContainer: {
        marginTop: 5,
        marginLeft: 20
    },
    stepText: {
        fontSize: 18,
        fontWeight: '300',
        color: 'gray',
        paddingLeft:"50px",
        fontFamily: "Roboto",
        paddingTop:"10px"
    },
    completeCircle: {
        width: 40,
        height: 40,
        borderRadius: 20,
        backgroundColor: '#458B00',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        shadowColor: '#000000',
        shadowOffset: { width: 10, height: 10 },
        shadowOpacity: 10,
        elevation: 3,
        color: '#fff',
        float:"left",
        border:"none",
        outline:"none",
        cursor:"pointer",
        paddingBottom:"5px"

    },
    whiteText: {
        color: '#fff',
        fontSize: 25,
        textAlign:"center",
        paddingTop:"5px",
        fontFamily: "Roboto",
    },
    blackText: {
        color: '#000',
        fontSize: 25,
        textAlign:"center",
        paddingTop:"5px",
        fontFamily: "Roboto",
    },
    incompleteCircle: {
        width: 40,
        height: 40,
        borderRadius: 20,
        backgroundColor: 'lightgray',
        justifyContent: 'center',
        alignItems: 'center',
        shadowColor: '#000000',
        shadowOffset: { width: 10, height: 10 },
        shadowOpacity: 10,
        elevation: 3,
        color: '#fff',
        float:"left",

    },
    inprogressCircle: {
        width: 40,
        height: 40,
        borderRadius: 20,
        backgroundColor: '#1976d2',
        justifyContent: 'center',
        alignItems: 'center',
        shadowColor: '#000000',
        shadowOffset: { width: 10, height: 10 },
        shadowOpacity: 10,
        elevation: 3,
        color: '#fff',
        float:"left"

    },
    checkIcon:{
        color:"white",
        height:"27px",
        width:"27px",
        position:"relative",
        top:"3px"
    }
});